import { render } from "./AddReviewerModel.vue?vue&type=template&id=102f7a9a&scoped=true"
import script from "./AddReviewerModel.js?vue&type=script&lang=js"
export * from "./AddReviewerModel.js?vue&type=script&lang=js"

import "./AddReviewerModel.vue?vue&type=style&index=0&id=102f7a9a&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-102f7a9a"]])

export default __exports__